import { Base } from '@studiometa/js-toolkit';

/**
 * PriceRange class.
 */
export default class MobileView extends Base {
  static config = {
    name: 'MobileView',
    refs: ['full', 'grid'],
  };

  /**
   * Mounted.
   */
  mounted() {
    const collectionGrid = document.querySelector('.collection-grid');
    this.$refs.full.addEventListener('click', () => {
      collectionGrid.style.display = 'block';
    });

    this.$refs.grid.addEventListener('click', () => {
      collectionGrid.style.display = 'grid';
    });
  }
}
